import { BookmarkType, IBookmarkItem } from "helpers/bookmark";
import pluralize from "helpers/pluralize";
import useLabels from "hooks/useLabels";
import SearchBookmarkAsThread from "./SearchBookmarkAsThread";
import ThreadBookmark from "./ThreadBookmark";

type ThreadBookmarkListProps = {
  bookmarks: IBookmarkItem[];
};

/**
 * @component ThreadBookmarkList
 * @description A list of bookmarked threads
 */
function ThreadBookmarkList({ bookmarks }: ThreadBookmarkListProps) {
  const [labels] = useLabels("features.bookmark-lists.bookmark-list-detail");

  return (
    <div>
      <div className="flex items-center py-2 border-b min-h-14 border-border-base">
        <div className="flex-1 base-bold">
          {pluralize(labels["n-threads"], {
            THREAD_COUNT: bookmarks?.length ?? 0,
          })}
        </div>
      </div>
      <div>
        {bookmarks.map((bookmark) => {
          if (bookmark.bookmark_type === BookmarkType.THREAD) {
            return <ThreadBookmark key={bookmark.id} bookmark={bookmark} />;
          } else if (bookmark.bookmark_type === BookmarkType.SEARCH) {
            return (
              <SearchBookmarkAsThread key={bookmark.id} bookmark={bookmark} />
            );
          }
        })}
      </div>
    </div>
  );
}

export default ThreadBookmarkList;
